// frontend/src/operator/OperatorRouteGuard.js
// 運営エリアへのアクセスを守るゲート。
// - 未ログイン → 運営ログイン (/{OPERATOR_PATH}/login) にリダイレクト
// - is_superadmin = false → 運営ログインへ (存在自体を漏らさない)
// - AAL2 ではない → 運営ログイン (MFA チャレンジ) へ

import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../supabase';

const OPERATOR_PATH = process.env.REACT_APP_OPERATOR_PATH || 'ops-7k3m9x2p4r8q';

export default function OperatorRouteGuard({ children }) {
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      if (!sessionData?.session) {
        if (!cancelled) setState({ loading: false, allowed: false });
        return;
      }

      // is_superadmin チェック
      const { data: isSuper, error: rpcError } = await supabase.rpc('is_superadmin');
      if (rpcError || !isSuper) {
        if (!cancelled) setState({ loading: false, allowed: false });
        return;
      }

      // AAL2 チェック
      const { data: aal } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
      if (aal?.currentLevel !== 'aal2') {
        if (!cancelled) setState({ loading: false, allowed: false });
        return;
      }

      if (!cancelled) setState({ loading: false, allowed: true });
    };

    check();

    // 認証状態変化を監視（ログアウト時など）
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      check();
    });

    return () => {
      cancelled = true;
      subscription?.unsubscribe();
    };
  }, []);

  if (state.loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a', color: '#fff' }}>
        確認中...
      </div>
    );
  }

  if (!state.allowed) {
    return <Navigate to={`/${OPERATOR_PATH}/login`} replace />;
  }

  return children;
}
